import { DataNotFoundImage, EmotionsBgBottomImage, EmotionsBgTopImage, InfoIcon } from 'assets'
import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { useSelector } from 'react-redux'
import { formatNumber } from 'utils/formatNumber'
import {
   getEmotionFColor,
   getEmotionIcon,
   getEmotionSColor,
   getEmotionSvgIcon
} from 'utils/getEmotionIcon'

function DVEmotionsScore() {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails: videoDetailsData } = videoRedux
   const [notFoundChart, setNotFoundChart] = useState(false)

   useEffect(() => {
      if (
         videoDetailsData?.positive_percentage === 0 &&
         videoDetailsData?.neutral_percentage === 0 &&
         videoDetailsData?.negative_percentage === 0
      ) {
         setNotFoundChart(true)
      } else {
         setNotFoundChart(false)
      }
      return () => {}
   }, [videoDetailsData])

   return (
      <div className="emotion-score-image">
         <div className="card">
            <div className="emotion-score-section">
               <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <p className="at-text-dark at-font-20">Sentiment Breakdown</p>
                  <InfoIcon />
               </div>
               {/* <p className="at-text-light mt-2 at-font-14">Last updated 2 min ago</p> */}
               {notFoundChart ? (
                  <div className="not-found-section">
                     <img
                        src={DataNotFoundImage}
                        alt="DataNotFoundImageF"
                        className="not-found-image"
                     />
                     <p>This YouTube Channel is Now Connected to Atenya! </p>
                  </div>
               ) : (
                  <div className=" mt-4">
                     <div className="d-flex align-baseline gap-4 flex-wrap">
                        
                        <div className="d-flex gap-3 flex-wrap">
                           <GenerateTooltip
                              label={'Positive'}
                              showArr={videoDetailsData?.top_positive_comments}
                              seriesIndex={0}
                              type={'positive'}
                           />
                           <GenerateTooltip
                              label={'Negative'}
                              showArr={videoDetailsData?.top_negative_comments}
                              seriesIndex={1}
                              type={'negative'}
                           />
                        </div>
                        <div>
                           <div className="chart-legend">
                              <div className="chart-details">
                                 <h3 className="at-text-dark score-title">
                                    {videoDetailsData?.positive_percentage}%
                                 </h3>
                                 <small>
                                    {/* <span className="improved-text">+2.4%</span> */}
                                    <span className="ms-2 at-text-dark">
                                       {videoDetailsData?.positive_comments || 0}
                                    </span>
                                 </small>
                              </div>
                              <div className="legend-icon-section">
                                 <div className="legend-dot positiv"></div>
                                 <p className="at-text-dark">Positive</p>
                              </div>
                           </div>
                           <div className="chart-legend mt-3">
                              <div className="chart-details">
                                 <h3 className="at-text-dark score-title">
                                    {videoDetailsData?.neutral_percentage}%
                                 </h3>
                                 <small>
                                    {/* <span className="improved-text">+2.4%</span> */}
                                    <span className="ms-2 at-text-dark">
                                       {videoDetailsData?.neutral_comments || 0}
                                    </span>
                                 </small>
                              </div>
                              <div className="legend-icon-section">
                                 <div className="legend-dot neutral"></div>
                                 <p className="at-text-dark">Neutral</p>
                              </div>
                           </div>
                           <div className="chart-legend mt-3">
                              <div className="chart-details">
                                 <h3 className="at-text-dark score-title">
                                    {videoDetailsData?.negative_percentage}%
                                 </h3>
                                 <small>
                                    {/* <span className="improved-text">+2.4%</span> */}
                                    <span className="ms-2 at-text-dark">
                                       {videoDetailsData?.negative_comments || 0}
                                    </span>
                                 </small>
                              </div>
                              <div className="legend-icon-section">
                                 <div className="legend-dot negative"></div>
                                 <p className="at-text-dark">Negative</p>
                              </div>
                           </div>
                        </div>
                        <div className=" pie-chart">{!loading && <PolarAreaChart />}</div>
                     </div>
                  </div>
               )}
            </div>
         </div>
      </div>
   )
}

export default DVEmotionsScore

const PolarAreaChart = () => {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { videoDetails: videoDetailsData } = videoRedux

   const [options, setOptions] = useState(null)
   const [series, setSeries] = useState([46, 37, 17])

   useEffect(() => {
      if (videoDetailsData) {
         setSeries([
            videoDetailsData?.positive_percentage,
            videoDetailsData?.neutral_percentage,
            videoDetailsData?.negative_percentage
         ])
      } else {
         setSeries(null)
      }
      return () => {}
   }, [videoDetailsData])

   useEffect(() => {
      setOptions({
         chart: {
            width: 380,
            type: 'donut',
            dropShadow: {
               enabled: true,
               top: 10,
               left: 0,
               blur: 5,
               color: '#000',
               opacity: 0.1
            }
         },
         dataLabels: {
            enabled: false
         },
         labels: ['Positive', 'Neutral', 'Negative'],
         fill: {
            type: 'gradient',
            colors: ['#51f430', '#426cf5', '#f5310f']
         },
         stroke: {
            width: 0
         },

         yaxis: {
            show: false
         },

         legend: {
            show: false
         },
         tooltip: {
            enabled: false
         }
      })
      return () => {}
   }, [videoDetailsData])

   return (
      <div>
         <div id="chart">
            {options && series && (
               <ReactApexChart options={options} series={series} type="donut" height={250} />
            )}
         </div>
         <svg
            width="200"
            height="200"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: 'absolute' }}>
            <defs>
               {/* Positive Gradient */}
               <linearGradient id="gradientPositive" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#00FF47', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#19B978', stopOpacity: 1 }} />
               </linearGradient>
               {/* Neutral Gradient */}
               <linearGradient id="gradientNeutral" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#3D6DC8', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#0066FF', stopOpacity: 1 }} />
               </linearGradient>
               {/* Negative Gradient */}
               <linearGradient id="gradientNegative" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#FF5136', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#FFD600', stopOpacity: 1 }} />
               </linearGradient>
            </defs>
         </svg>
         <div id="html-dist"></div>
      </div>
   )
}

const GenerateTooltip = ({ label, showArr, type }) => {
   return (
      <div className="chart-tooltip">
         <p className="chart-tooltip-title">Top {label} Emotion</p>
         {showArr && showArr?.map((item, index) => (
            <div key={index} className="tooltip-section">
               <div
                  className="progress"
                  style={{ backgroundColor: '#FFFFFF14', borderRadius: '32px' }}>
                  <div
                     className="progress-bar"
                     role="progressbar"
                     style={{
                        borderRadius: '32px',
                        width: `${item.per}%`,
                        background: `linear-gradient(61.59deg, ${getEmotionSColor(
                           item?.text,
                           type
                        )} 0%, ${getEmotionFColor(item?.text, type)} 99.45%)`
                     }}
                     aria-valuenow={item.per}
                     aria-valuemin={0}
                     aria-valuemax={100}></div>
               </div>
               <div className="d-flex align-items-center justify-content-between mt-1">
                  <div className="d-flex align-items-center gap-2">
                     <span className="emotion-chart-icon">{getEmotionIcon(item?.text, type)}</span>
                     <span className="text-capitalize">{item.text}</span>
                  </div>
                  <span>{item.count}</span>
               </div>
            </div>
         ))}
      </div>
   )
}
